// extracted by mini-css-extract-plugin
export var linkText = "_pt-0";